<template>
    <div>
        <b-breadcrumb :items="items"/>
        <div class="container-fluid" style="background-color: white">
            <br>
            <span style="text-align: center">
                <header-title title="สร้างใบรับสินค้า"></header-title>
            </span>
            <div class="row">
                <div class="col-sm-6">
                    <!--start date-->
                    <div class="form-group row">
                        <label class="col-sm-4 col-form-label text-capitalize text-right">
                            วันที่
                        </label>
                        <div class="col-sm-6">
                            <date-picker
                                v-model="form.date"
                                type="date"
                                class="w-100"
                                @input="generateRR"
                                :disabled="disable_date"
                                :format="changeFormat"
                                :lang="lang"
                                placeholder="วันที่สร้าง">
                            </date-picker>
                        </div>
                    </div>
                    <!--start vendor-->
                    <div class="form-group row">
                        <label class="col-sm-4 col-form-label text-capitalize text-right">
                            รหัสผู้จำหน่าย
                        </label>
                        <div class="col-sm-6">
                            <multiselect
                                v-model="form.vendor"
                                :options="po_vendor"
                                track-by="vendor_id"
                                :customLabel="LabelVendor"
                                :show-labels="false"
                                @input="searchByVendor(form.vendor)"
                                placeholder="เลือกผู้จำหน่าย">
                            </multiselect>
                        </div>
                    </div>
                    <!--Vendor data-->
                    <template v-if="form.vendor">
                        <div class="form-group row">
                            <label
                                class="col-sm-4 col-form-label text-capitalize text-right">
                                ผู้จำหน่าย
                            </label>
                            <div class="col-sm-8 col-form-label">
                                <p>
                                    {{ form.vendor.first_name }}
                                    {{ form.vendor.last_name }}
                                </p>
                                <p>{{ form.vendor.address }}</p>
                                <p>โทร {{ form.vendor.phone }}</p>
                            </div>
                        </div>
                    </template>
                </div>
                <div class="col-sm-6">
                    <!--rr number-->
                    <div class="form-group row">
                        <label class="col-sm-4 col-form-label text-capitalize text-right">
                            เลขที่เอกสาร
                        </label>
                        <div class="col-sm-8">
                            <masked-input v-model="form.RR_number"
                                          mask="RR111111111"
                                          placeholder="เลขที่ RR"
                                          class="form-control"
                                          type="text"/>
                        </div>
                    </div>
                </div>
                <br>
            </div>
            <div class="col-sm-12 table-responsive">
                <table class="table table-bordered text-center">
                    <thead>
                    <tr>
                        <th scope="col">#ใบจอง</th>
                        <th scope="col">สถานะภาษี</th>
                        <th scope="col">รหัสสินค้า</th>
                        <th scope="col">ชื่อสินค้า</th>
                        <th scope="col">ค้าง pack</th>
                        <th scope="col" width="100px">ส่ง-pack</th>
                        <th width="100px" scope="col">ราคา</th>
                        <th scope="col">จำนวนเงินรวมทั้งหมด</th>
                        <th scope="col">ตัดจบ</th>
                        <!--<th scope="col">ตัดเกินจำนวน</th>-->
                    </tr>
                    </thead>
                    <tbody>
                    <template v-for="data in po_list">
                        <template v-for="info in data.details">
                            <tr>
                                <td>{{ data.po_number }}</td>
                                <td>
                                    <template v-if="data.status_tax">
                                        <span style="color: green;">มีภาษี</span>
                                    </template>
                                    <template v-else>
                                        <span style="color: red;">ไม่มีภาษี</span>
                                    </template>
                                </td>
                                <td>
                                    <template v-if="info.material">
                                        {{ info.material.code }}
                                    </template>
                                    <template v-else>-</template>
                                </td>
                                <td>
                                    <template v-if="info.material">
                                        {{ info.material.name }}
                                    </template>
                                    <template v-else>-</template>
                                </td>
                                <td>{{ info.remaining | amount }}</td>
                                <td>
                                    <input class="form-control"
                                           type="text" v-on:input="totalAmount"
                                           v-model="info.pack_receive"
                                           min="0" :max="info.remaining"
                                           :disabled="info.status==2 || info.status==3"/>
                                </td>
                                <td width="120px">
                                    <input type="text" class="form-control"
                                           v-on:input="totalAmount"
                                           v-model="info.unit_price"/>
                                </td>
                                <td width="80px">
                                    {{
                                        info.pack_receive
                                            ? (parseFloat(info.pack_receive) * parseFloat(info.unit_price))
                                            : (parseFloat(0) * parseFloat(info.unit_price)) | currency
                                    }}
                                </td>
                                <td>
                                    <button type="button"
                                            v-if="info.status==1 || info.status == 3"
                                            v-on:click="() => { info.status = 2 }"
                                            :disabled="info.status == 3"
                                            class="btn btn-danger"><b>ตัดจบ</b>
                                    </button>
                                    <button type="button"
                                            v-if="info.status==2"
                                            v-on:click="() => { info.status = 1 }"
                                            class="btn btn-default"><b>ยกเลิก</b>
                                    </button>
                                </td>
                                <!--<td>-->
                                <!--<button type="button"-->
                                <!--v-if="info.status==1 || info.status == 2"-->
                                <!--v-on:click="() => { info.status = 3; info.pack_receive = info.remaining}"-->
                                <!--:disabled="info.status==2"-->
                                <!--@click="totalAmount"-->
                                <!--class="btn btn-success"><b>ตัดเกินจำนวน</b>-->
                                <!--</button>-->
                                <!--<button type="button"-->
                                <!--v-if="info.status==3"-->
                                <!--v-on:click="() => { info.status = 1 }"-->
                                <!--class="btn btn-default"><b>ยกเลิก</b>-->
                                <!--</button>-->
                                <!--</td>-->
                            </tr>
                            <!--เพิ่มแถว ตัดเกินจำนวน-->
                            <tr v-if="info.status==3">
                                <td>{{ data.po_number }}</td>
                                <td>
                                    <template v-if="data.status == 3">
                                        <span style="color:red">มีมัดจำ</span>
                                    </template>
                                    <template v-else>-</template>
                                </td>
                                <td>
                                    <template v-if="data.status_tax==0">
                                        <span style="color: green;">ไม่มีภาษี</span>
                                    </template>
                                    <template v-else-if="data.status_tax==1">
                                        <span style="color: red;">มีภาษี</span>
                                    </template>
                                    <template v-else>
                                        -
                                    </template>
                                </td>
                                <td>
                                    <template v-if="info.material">
                                        {{ info.material.code }}
                                    </template>
                                    <template v-else>-</template>
                                </td>
                                <td>
                                    <template v-if="info.material">
                                        {{ info.material.name }}
                                    </template>
                                    <template v-else>-</template>
                                </td>
                                <td>0</td>
                                <td>
                                    <input class="form-control"
                                           v-model="info.over_quantity"
                                           v-on:input="totalAmount"
                                           type="text"/>
                                </td>
                                <td>
                                    <input type="text"
                                           v-model="info.over_price"
                                           v-on:input="totalAmount"
                                           class="form-control"/>
                                </td>
                                <td>
                                    <template v-if="info.over_price">
                                        {{ info.over_price * info.over_quantity }}
                                    </template>
                                    <template v-else>0</template>

                                </td>
                                <td></td>
                                <td></td>
                            </tr>
                        </template>
                    </template>
                    </tbody>
                </table>
            </div>
            <b-row style="padding-right: 35px">
                <div class="float-right; text-right" style="margin-left: auto;">
                    <table style="font-size: 18px ; text-align: right">
                        <tr>
                            <td width="150">รวมทั้งหมด :</td>
                            <td>
                                <template v-if="tax_status_purchase == 1">
                                    {{ total | currency }} บาท
                                </template>
                                <template v-else>
                                    {{ total - calculateTax | currency }} บาท
                                </template>
                            </td>
                        </tr>
                        <tr>
                            <td>ภาษีมูลค่าเพิ่ม 7% :</td>
                            <td>{{ calculateTax | currency }} บาท</td>
                        </tr>
                        <tr>
                            <td>ส่วนลดอื่นๆ :</td>
                            <td>
                                <input type="number" class="form-control input-style" v-model="form.other_discount"/>
                            </td>
                        </tr>
                        <tr style="height: 50px">
                            <td>รายจ่ายอื่นๆ :</td>
                            <td><input type="number" class="form-control input-style" v-model="form.other_income"/></td>
                        </tr>
                        <tr>
                            <td>ยอดรวม :</td>
                            <td>{{ calculateTotal | currency }} บาท</td>
                        </tr>
                    </table>
                </div>
            </b-row>
            <br/>
            <!--check receive pack-->
            <input type="hidden" v-model="checkRemainPack"/>
            <div v-if="vendor_confirm == true" class="text-right">
                <button @click="saveRROrder"
                        class="btn btn-default mb-3 next"
                        style="margin-right: 20px">
                    <icon name="check"></icon>
                    ยืนยันการรับสินค้า
                </button>
            </div>
        </div>
        <!--        <pre class="alert-primary">{{po_data}}</pre>-->
        <!--<pre class="alert-success">{{po_vendor}}</pre>-->
    </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import {mapState} from "vuex";
import HeaderTitle from "../../HeaderTitle";
import moment from "moment";
import DatePicker from 'vue2-datepicker'
import MaskedInput from 'vue-masked-input'

export default {
    name: "rr-order-form",
    props: {
        id: {default: null}
    },
    components: {
        HeaderTitle,
        DatePicker,
        Multiselect,
        MaskedInput
    },
    data() {
        return {
            disable_date: false,
            status_list: 1,
            po_data: [],
            details: [],
            vendor_confirm: false,
            po_vendor: [],
            over_quantity: "",
            over_price: "",
            total: 0,
            inc_tax: 0,
            tax_status_purchase: "",
            vat_1: 7,
            vat_2: 1.07,
            items: [
                {
                    text: "รายการสร้าง RR",
                    to: {name: "rr-list"}
                },
                {
                    text: "เพิ่มเติม",
                    active: true
                }
            ],
            check_receive: 1,
            changeFormat: {
                stringify: (date) => {
                    let date_moment = moment(date).format('YYYY');
                    const year = parseInt(date_moment) + 543;
                    //console.log(moment(date).format('DD/MM/'+year));
                    return date ? moment(date).format('DD/MM/' + year) : null
                },
                parse: (value) => {
                    return value ? moment(value, 'DD/MM/YYYY').subtract(543, 'y').toDate() : null
                }
            },
            lang: {
                days: ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส'],
                months: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
                pickers: ['ถัดไป 7 วัน', 'ถัดไป 30 วัน', 'ก่อนหน้า 7 วัน', 'ก่อนหน้า 30 วัน'],
                placeholder: {
                    date: 'วว/ดด/ปปปป',
                }
            },
        }
    },
    created() {
        if (!this.id) {
            this.$store.dispatch('RROrder/clearform');
            this.generateRR();
        } else {
            this.disable_date = true;
        }
        this.getVendorAll();
        this.$store.dispatch('PurchaseOrder/getAll').then(res => {
            //multiselect select vendor status po != 1//รอการอนุมัติ PO
            this.purchase_order = res.filter(po => po.status != 1);
            let po = [];
            this.po_vendor = [];
            this.purchase_order.forEach(data => {
                Object.keys(data.details).forEach(key => {
                    if (data.details[key].status == 1) {
                        if (!po.includes(data.vendor.id)) {
                            po.push(data.vendor.id);
                            this.po_vendor.push(data.vendor);
                        }
                    }
                })
            });
        });
    },
    computed: {
        ...mapState({
            form: state => {
                return state.RROrder.form;
            },
            po_list: state => {
                return state.RROrder.rr_vendor;
            },
            user: state => {
                return state.Auth.user;
            },
        }),
        credit_day() {
            const date = moment(this.form.date, "YYYY-MM-DD").add(this.form.credit_day, 'day');
            const new_date = moment(date).format("YYYY-MM-DD");
            this.form.payment_date = new_date;
            return new_date;
        },
        calculateTax() {
            if (this.tax_status_purchase == 1) {  //มีภาษี
                this.inc_tax = parseFloat(this.total) * (7 / 100);
            } else {
                let tax = this.total / 1.07;
                this.inc_tax = this.total - tax;
            }
            return this.inc_tax = parseFloat(this.inc_tax).toFixed(2);
        },
        calculateTotal() {
            let total = 0;
            let other_income = 0;
            let other_discount = 0;
            if (this.tax_status_purchase == 1) {
                total = parseFloat(this.total) + parseFloat(this.inc_tax)
            } else {
                total = parseFloat(this.total)
            }
            if (this.form.other_income > 0) {
                other_income = this.form.other_income;
            }
            if (this.form.other_discount > 0) {
                other_discount = this.form.other_discount;
            }
            total = parseFloat(total) + parseFloat(other_income) - parseFloat(other_discount)
            return parseFloat(total).toFixed(2);
        },
        checkRemainPack() {
            this.check_receive = 1;
            this.po_list.forEach(purchase => {
                purchase.details.forEach(detail => {
                    if (detail.pack_receive > detail.remaining) {
                        this.check_receive = parseFloat(this.check_receive) * parseFloat(0);
                    } else {
                        this.check_receive = parseFloat(this.check_receive) * parseFloat(1);
                    }
                });
            });
            return this.check_receive;
        }
    },
    methods: {
        LabelVendor(option) {
            return `${option.vendor_id} - ${option.name}`
        },
        searchByVendor(vendor) {
            if (vendor) {
                this.vendor_confirm = false;
                let vendor_id = vendor.id;
                this.$store.dispatch('RROrder/searchByVendor', vendor_id)
                    .then(() => {
                        this.vendor_confirm = true;
                    }).then(() => {
                    this.po_list.forEach(data => {
                        Object.keys(data.details).forEach(key => {
                            data.details[key].pack_receive = "";
                        })
                    })
                });
            } else {
                this.$store.dispatch('RROrder/clearform')
            }
        },
        getVendorAll() {
            this.$store.dispatch("PurchaseOrder/getVendorAll").then(res => {
                this.optionVendor = res;
            });
        },
        saveRROrder() {
            this.po_data = [];
            this.po_list.forEach(info => {
                Object.keys(info.details).forEach(key => {
                    if (info.details[key].pack_receive > 0 || info.details[key].status != 1) {
                        let details = {
                            id: info.details[key].id,
                            po_id: info.details[key].po_id,
                            po_number: info.po_number,
                            material_id: info.details[key].material_id,
                            quantity: info.details[key].quantity,
                            price: info.details[key].price,
                            discount: 0,
                            receive_pack: info.details[key].pack_receive,
                            remaining: info.details[key].remaining,
                            status: info.details[key].status,
                            over_quantity: info.details[key].over_quantity,
                            over_price: info.details[key].over_price,
                            unit_price: info.details[key].unit_price,
                        };
                        this.po_data.push(details);
                    }
                })
            });
            if (!this.form.vendor) {
                alert('กรุณาเลือกผู้จำหน่าย')
            } else {
                if (this.po_data.length < 1) {
                    alert("กรุณาใส่จำนวนสินค้าที่ได้รับ");
                } else {
                    this.form.total = this.total;
                    this.form.tax_rate = this.calculateTax;
                    this.form.tax_total = this.inc_tax;
                    this.form.status_tax = this.tax_status_purchase;
                    if (this.form.date) {
                        this.form.date = moment(this.form.date).format("YYYY-MM-DD");
                    } else {
                        this.form.date = "";
                    }
                    //console.log(this.form);
                    this.$store.dispatch('RROrder/create', {
                        details: this.po_data,
                        user: this.user.id,
                    }).then(res => {
                        if (res) {
                            this.$router.push({
                                name: "rr-list"
                            })
                        } else {
                            alert('เลข RR ซ้ำ กรุณากรอกใหม่อีกครั้ง');
                        }
                    })
                }
            }
        },
        totalAmount() {
            let sum = 0;
            this.total = 0;
            this.po_list.forEach(purchase => {
                purchase.details.forEach(detail => {
                    if (!detail.unit_price) {
                        detail.unit_price = 0;
                    }
                    if (detail.pack_receive) {
                        sum = sum + ((parseFloat(detail.unit_price) * parseFloat(detail.pack_receive)))
                        if (!detail.over_quantity || !detail.over_price) {
                            sum = sum + parseFloat(0);
                        } else {
                            sum = sum + ((parseFloat(detail.over_quantity) * parseFloat(detail.over_price)))
                        }
                        this.tax_status_purchase = purchase.status_tax;
                    }
                });
            });
            this.total = sum.toFixed(2);
        },
        generateRR() {
            if (this.form.date) {
                let date = moment(this.form.date).format('YYYY-MM-DD');
                this.$store.dispatch('RROrder/generateRR', date).then(res => {
                    this.form.RR_number = res;
                });
            }
        }
    }
}
</script>

<style lang="scss" scoped>
thead {
    background-color: gray;
}

tbody {
    background-color: white;
}

.input-style {
    text-align: right;
    width: 150px;
}
</style>
